/* This store is never persisted, and therefore does not survive a page reload. */

import mitt from 'mitt';
import ActionTypes from '@/store/constants/actions';
import MutationTypes from '../constants/mutations';
import GetterTypes from '../constants/getters';

const foodAndBeverages = require('@icons/streamline-icons/Outline version/26-Food-Drinks/04-Fastfood/fast-food-pizza-slice.svg');
const accommodation = require('@icons/streamline-icons/Outline version/24-Hotels-Spas/01-Hotel-Bedrooms/hotel-double-bed-1.svg');
const merchandise = require('@icons/streamline-icons/Outline version/09-Shopping-Ecommerce/08-Baskets/shopping-basket-rating.svg');
const travel = require('@icons/streamline-icons/Outline version/23-Travel/04-Planes-Trip/plane-1.svg');
const print = require('@icons/streamline-icons/Outline version/03-Computers-Devices-Electronics/17-Scan-Print/printer.svg');
const wardrobe = require('@icons/streamline-icons/Outline version/25-Wayfinding/08-Cloak-Lockers-Room/locker-room-hanger.svg');
const misc = require('@icons/streamline-icons/Outline version/22-Social-Medias-Rewards-Rating/06-Rating/rating-star-bubble-1.svg');

const iconMapping = {
  2: foodAndBeverages,
  3: accommodation,
  4: merchandise,
  5: travel,
  6: print,
  7: wardrobe,
  8: misc,
};

export default {
  state: {
    isAllLoaded: false,
    menuEventBus: mitt(),
    omniSearchEventBus: mitt(),
    showMenu: false,
    backgroundImage: null,
    merchandiseTypes: [],
  },
  getters: {
    [GetterTypes.IS_ALL_LOADED]: (state) => state.isAllLoaded,
    [GetterTypes.MENU_EVENT_BUS]: (state) => state.menuEventBus,
    [GetterTypes.OMNI_SEARCH_EVENT_BUS]: (state) => state.omniSearchEventBus,
    [GetterTypes.SHOW_MENU]: (state) => state.showMenu,
  },
  mutations: {
    [MutationTypes.MARK_IS_ALL_LOADED]: (state) => {
      state.isAllLoaded = true;
    },
    [MutationTypes.SET_SHOW_MENU]: (state, shouldShow) => {
      state.showMenu = shouldShow;
    },
    [MutationTypes.TOGGLE_MENU]: (state) => {
      state.showMenu = !state.showMenu;
    },
    [MutationTypes.SIGN_OUT]: (state) => {
      state.isAllLoaded = false;
    },
    [MutationTypes.SET_MERCHANDISE_TYPES]: (state, merchandiseTypes) => {
      state.merchandiseTypes = merchandiseTypes;
    },
  },
  actions: {
    [ActionTypes.LOAD_MERCHANDISE_TYPES]({ commit, state }) {
      if (!state.merchandiseTypes?.length) {
        return this.$axios.get('ticketsystem/merchandise/list_merchandisetypes')
          .then(({ data }) => data.map((merchType) => ({
            ...merchType,
            icon: iconMapping[merchType.id],
          })))
          .then((data) => {
            commit(MutationTypes.SET_MERCHANDISE_TYPES, data);
            return state.merchandiseTypes;
          });
      }
      return Promise.resolve(state.merchandiseTypes);
    },
  },
};
